// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"BreadcrumbsBar_breadcrumbs__1XlBD"};